import type { ReactNode } from 'react'

/**
 * Ein Leerzustand sagt, was fehlt — und bietet den Weg dorthin an. Eine leere
 * Fläche mit „Keine Daten" ist eine Sackgasse.
 */
export function Empty({
  titel,
  text,
  aktion,
}: {
  titel: string
  text: string
  aktion?: ReactNode | undefined
}) {
  return (
    <div className="leerzustand">
      <h3 className="leerzustand__titel">{titel}</h3>
      <p className="leerzustand__text">{text}</p>
      {aktion}
    </div>
  )
}
